import { render, staticRenderFns } from "./BitHideTab.vue?vue&type=template&id=0d8145f6&scoped=true"
import script from "./BitHideTab.vue?vue&type=script&lang=js"
export * from "./BitHideTab.vue?vue&type=script&lang=js"
import style0 from "./BitHideTab.vue?vue&type=style&index=0&id=0d8145f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8145f6",
  null
  
)

export default component.exports